import Navbar from "../components/common/Navbar";
import "../styles/common/Error404.css";

const error404 = () => {
  return (
    <div>
      <Navbar />
    </div>
  );
};

export default error404;
